import { ActionTypes } from './action-types';
import { IUser, IRole, IGroup } from "../../models";

import { IUserListState } from "./state";

// reducer interfaces

interface ISetUsers {
    type: string,
    list: IUser[]
}

interface ISetRoles {
    type: string,
    list: IRole[]
}

interface ISetGroups {
    type: string,
    list: IGroup[]
}

interface IAddUser {
    type: string,
    user: IUser
}

interface IUpdateUser {
    type: string,
    user: IUser
}

var initialState: IUserListState = {
    list: [],
    roles: [],
    groups: []
};

// reducer functions

const setUsers = (state: IUserListState, action: ISetUsers) => {
    state.list = action.list;
    return state;
}

const setRoles = (state: IUserListState, action: ISetRoles) => {
    state.roles = action.list;
    return state;
}

const setGroups = (state: IUserListState, action: ISetGroups) => {
    state.groups = action.list;
    return state;
}

const addUser = (state: IUserListState, action: IAddUser) => {
    state.list.push(action.user);
    return state;
}

const updateUser = (state: IUserListState, action: IUpdateUser) => {
    state.list = state.list.map(user => {
        if (user.id == action.user.id)
            return action.user;
        else
            return user;
    });

    return state;
}

const createReducer = (initialState: IUserListState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = Object.assign({}, state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers = {
    [ActionTypes.SET_USERS]: setUsers,
    [ActionTypes.SET_ROLES]: setRoles,
    [ActionTypes.SET_GROUPS]: setGroups,
    [ActionTypes.ADD_USER]: addUser,
    [ActionTypes.UPDATE_USER]: updateUser
};

export const Reducer = createReducer(initialState, handlers);
